module.exports = __webpack_public_path__ + "img/level_4.a232c160.svg";